<template>
	<div class="relative inline-block">
		<!-- btn-disabled styling WITHOUT the disabled attribute so the button stays
		     clickable (DaisyUI's btn-disabled sets pointer-events:none — force it back on). -->
		<button
			type="button"
			class="btn btn-sm btn-outline btn-disabled !pointer-events-auto"
			aria-disabled="true"
			@click="$refs.popover.open()"
		>
			<slot name="icon" />
			{{ label }}
		</button>

		<Dropdown ref="popover" position="bottom-start" class="w-72" teleport>
			<div class="bg-base rounded-box shadow-lg border border-base-200 p-4 text-sm font-normal normal-case text-left">
				<p>{{ instruction }}</p>
				<a
					v-if="CTAText"
					href="#"
					@click="handleCTAClick"
					class="link link-accent mt-2 inline-block"
				>
					{{ CTAText }} »
				</a>
			</div>
		</Dropdown>
	</div>
</template>

<script lang="ts">
import Dropdown from "@/components/ui/Dropdown.v2.vue";

export default {
	emits: ['clickCTA'],

	components: {
		Dropdown,
	},

	props: {
		label: {
			type: String,
			required: true,
		},

		instruction: {
			type: String,
			required: true,
		},

		CTAText: {
			type: String,
			default: '',
		},
	},

	methods: {
		handleCTAClick(event: Event) {
			// close the popover and prevent the link from navigating away (the parent handles the click)
			this.$refs.popover.close();
			event.preventDefault();
			this.$emit('clickCTA');
		},
	},
};
</script>
